import type { OperationalReportId } from '@shared/operational-reports.ts';
import type { RangeParams, Section } from './shared.tsx';
import { OperationalSection } from './sections/operational.tsx';
import { ProfitabilitySection } from './sections/profitability.tsx';
import { JobProfitSection } from './sections/job-profit.tsx';
import { JobCostingSection } from './sections/job-costing.tsx';
import { RetentionSection } from './sections/retention.tsx';
import { FunnelSection } from './sections/funnel.tsx';
import { ReceivablesSection } from './sections/receivables.tsx';
import { CrewSection } from './sections/crew.tsx';
import { CapacitySection } from './sections/capacity.tsx';
import { LeadsSection } from './sections/leads.tsx';

const OPERATIONAL_SECTIONS: ReadonlySet<Section> = new Set([
  'money-received',
  'quality-response',
  'cancellations',
  'add-ons',
]);

/** One report's body: the component that reads and draws that section's endpoint. */
export function ReportSectionBody({ section, range, scope }: { section: Section; range: RangeParams; scope?: 'all' }) {
  if (OPERATIONAL_SECTIONS.has(section)) {
    return <OperationalSection reportId={section as OperationalReportId} range={range} scope={scope} />;
  }
  switch (section) {
    case 'profitability':
      return <ProfitabilitySection range={range} scope={scope} />;
    case 'jobProfit':
      return <JobProfitSection range={range} scope={scope} />;
    case 'jobCosting':
      return <JobCostingSection range={range} scope={scope} />;
    case 'retention':
      return <RetentionSection scope={scope} />;
    case 'funnel':
      return <FunnelSection range={range} scope={scope} />;
    case 'receivables':
      return <ReceivablesSection scope={scope} />;
    case 'crew':
      return <CrewSection range={range} scope={scope} />;
    case 'capacity':
      return <CapacitySection scope={scope} />;
    case 'leads':
      return <LeadsSection range={range} scope={scope} />;
    default:
      return null;
  }
}
